// ════════════════════════════════════════════════════════════
// Auth Store (Zustand) — ECR
// ════════════════════════════════════════════════════════════
// État d'auth en mémoire. PAS de persist : Supabase gère son
// propre storage pour la session (cf. lib/supabase.ts).
//
// Initialisé une fois au boot dans main.tsx via bootstrapAuth().
// Synchronisé via supabase.auth.onAuthStateChange().
// ════════════════════════════════════════════════════════════
import { create } from 'zustand';
import type { Session } from '@supabase/supabase-js';
import type { Profile } from '@/types/auth';

interface AuthState {
  session: Session | null;
  profile: Profile | null;
  isLoading: boolean;
  setSession: (session: Session | null) => void;
  setProfile: (profile: Profile | null) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  profile: null,
  isLoading: true,
  setSession: (session) => {
    set({ session });
  },
  setProfile: (profile) => {
    set({ profile });
  },
  setLoading: (isLoading) => {
    set({ isLoading });
  },
  reset: () => {
    set({ session: null, profile: null });
  },
}));
